import { render, staticRenderFns } from "./map-chart.vue?vue&type=template&id=23ddf6ea&"
import script from "./map-chart.vue?vue&type=script&lang=js&"
export * from "./map-chart.vue?vue&type=script&lang=js&"
import style0 from "./map-chart.vue?vue&type=style&index=0&id=23ddf6ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports